var axios = require('axios');
var auth = require('./auth');

function floopback(model) {
  this.model = model;
}

floopback.prototype.find = function(lbFilter) {
  let _this = this;
  return new Promise(function(resolve, reject) {
    var filter = JSON.stringify(lbFilter);
    var url =
      process.env.REACT_APP_URL_API +
      '/api/' +
      _this.model +
      '?filter=' +
      filter;
    axios.get(url).then(function(result) {
      resolve(result.data);
    });
  });
};

floopback.prototype.findById = function(id, lbFilter = {}) {
  let _this = this;
  return new Promise(function(resolve, reject) {
    var filter = JSON.stringify(lbFilter);

    var url =
      process.env.REACT_APP_URL_API +
      '/api/' +
      _this.model +
      '/' +
      id +
      '?filter=' +
      filter;
    axios.get(url).then(function(result) {
      resolve(result.data);
    });
  });
};

floopback.prototype.create = function(body) {
  let _this = this;
  return new Promise(function(resolve, reject) {
    var url = process.env.REACT_APP_URL_API + '/api/' + _this.model;
    axios.post(url, body).then(function(result) {
      resolve(result.data);
    });
  });
};

floopback.prototype.update = function(id, body) {
  let _this = this;
  return new Promise(function(resolve, reject) {
    var url = process.env.REACT_APP_URL_API + '/api/' + _this.model + '/' + id;
    axios.patch(url, body).then(function(result) {
      resolve(result.data);
    });
  });
};

floopback.prototype.delete = function(id) {
  let _this = this;
  return new Promise(function(resolve, reject) {
    var url = process.env.REACT_APP_URL_API + '/api/' + _this.model + '/' + id;
    axios.delete(url).then(function(result) {
      resolve(result.data);
    });
  });
};

floopback.prototype.replaceOrCreate = function(body) {
  let _this = this;
  return new Promise(function(resolve, reject) {
    var url = process.env.REACT_APP_URL_API + '/api/' + this.model;
    axios.post(url, body).then(function(result) {
      resolve(result.data);
    });
  });
};

module.exports = floopback;



// WEBPACK FOOTER //
// ./src/lib/floopback.js